import { configureStore } from "@reduxjs/toolkit";
import regionReducer from "./slices/regionSlice";
import userReducer from "./slices/userSlice";
import utilsReducer from "./slices/utilsSlice";
import cfsReducer from "./slices/cfsslice";
import farmersReducer from "./slices/farmerSlice";
const store = configureStore({
  reducer: {
    regions: regionReducer, // Register the region slice
    user: userReducer,
    utils: utilsReducer,
    cf: cfsReducer,
    farmer :farmersReducer

  },
});

export default store;
